export const getSearchValues = (searchValues: any, searchData: any) => {
  // let start = Date.now();
  let results = [];
  /*
   * searchValues is a array of either one search element(user types single word) or
   * array of multiple search elements (user types multiple space separated words)
   * in case of ROUTE type, search should be on name field, otherwise on searchString
   * split the search string from '|', and then check if each search term in the search values list matches with search string
   * Push one array each for each search term in final searchMatchesList array
   * and send the array of arrays to intersection function to find matching search element in all the arrays inside an array.
   */
  if (
    searchValues?.filter((val) => val !== '')?.length > 0 &&
    searchData?.length > 0
  ) {
    const searchMatchesLists = searchValues?.map((value) =>
      searchData?.filter((data) =>
        (data?.type === 'ROUTE' ? data?.name : data?.searchString)
          ?.split(data?.type === 'ROUTE' ? '/' : '|')
          .some((spec) =>
            spec
              ?.toLowerCase()
              ?.replace(/[-_]/g, '')
              ?.includes(value?.toLowerCase()?.replace(/[-_]/g, '')),
          ),
      ),
    );
    results = getIntersection(searchMatchesLists, 'searchString');
  } else {
    results = [];
  }
  return results;
};

/*
 * find intersection between 2 arrays containing objects based on the search prop provided.
 * prop is just a property which function uses to match 2 elements in different arrays
 */
const getIntersection = (lists: any[][], prop: string): any[] => {
  if (lists.length === 0) {
    return [];
  }
  if (lists.length === 1) {
    return lists[0];
  }
  const result = lists.reduce((prev, curr) => {
    return prev.filter((prevItem) => {
      return curr.some((currItem) => currItem[prop] === prevItem[prop]);
    });
  });
  return result;
};
